<template>
  <div class="my_font_style">
    <select_font_size
      width="200"
      type="one_level"
      :title="fontSizeTitle"
      :options="$store.state.options.fontSize"
      :value.sync="font_size"
      v-if="font_size !== undefined"
    ></select_font_size>

    <select_font_family :value.sync="font_family" ref="selectFontFamily"></select_font_family>

    <my_select type="one_level"
               v-if="false && font_family !== undefined"
               :value.sync="font_family"
               :title="fontFamilyTitle"
               :isGroup="hasCustomFont"
               :options="fontFamilyOptions"
               width="250"></my_select>
    <div class="setOne">
      <my_color :title="$t('widgets_basic_h1_edit_577')" class="minRight" type="one_level" :color.sync="color_value"></my_color>
      <!-- <my_text_biu class="hideTitle" type="one_level" :fsWeight.sync="fs_weight" :fsItalics.sync="fs_italics" :fsUnderline.sync="fs_underline"></my_text_biu> -->
      <div class="style_list my_text_biu_layer">
        <span class="text_biu_content">
          <i class="icon bold" :class="fs_weight == 'bold' ? 'active': ''" @click="clickBold"></i>
          <i class="icon italics" :class="fs_italics == 'oblique' ? 'active': ''" @click="clickItalics"></i>
          <i class="icon underline" :class="fs_underline == 'underline' ? 'active': ''" @click="clickUnderline"></i>
        </span>
      </div>
      <my_text_align type="one_level" :textAlign.sync="text_align"></my_text_align>
      <my_line_height type="one_level" :options="$store.state.options.lineHeight" :lineHeight.sync="line_height"
                      v-if="line_height !== undefined"></my_line_height>
      <p class="set_icon" @click="setLink"><span class="setting_icon setting_icon_link"></span></p>
      <p class="set_icon" @click="reSet"><span class="setting_icon setting_icon_clear"></span></p>
    </div>
    <div class="setTwo">
      <el-select class="h_tag_select" v-model="h_tag" size="small" @change="applyHTag">
        <el-option label="段落" value="p"></el-option>
        <el-option label="标题 1" value="h1"></el-option>
        <el-option label="标题 2" value="h2"></el-option>
        <el-option label="标题 3" value="h3"></el-option>
        <el-option label="标题 4" value="h4"></el-option>
        <el-option label="标题 5" value="h5"></el-option>
        <el-option label="标题 6" value="h6"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import select_font_size from '../my_font_size/components/select_font_size';
import select_font_family from '../my_font_family/index';
import {createFont} from '@/api/app.js'

export default {
  name: 'my_rich_text_style',
  components: {
    select_font_size, select_font_family
  },
  props: {
    textBiuTitle: {
      type: String,
      default: i18n.t('widgets_basic_h1_edit_577')
    },
    fontFamilyTitle: {
      type: String,
      default: i18n.t('widgets_basic_h1_edit_576')
    },
    fontSizeTitle: {
      type: String,
      default: i18n.t('widgets_basic_classification_edit_465')
    },
    fontSize: {},
    fontFamily: {},
    pattern: {
      type: String
    },
    linearGradient: {},
    lineHeight: {},
    colorValue: {
      type: String
    },
    selectColor: {
      type: String
    },
    fsWeight: {
      type: String
    },
    fsItalics: {
      type: String
    },
    fsUnderline: {
      type: String
    },
    textAlign: {
      type: String
    },
    lineIsShow: {
      type: String,
      default: 'true'
    },
    link: {
      type: Object
    },
    hasCustomFont: {
      type: Boolean,
      default: false
    },
    customFont: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fontList: {
      type: Array,
      default: () => {
        return []
      }
    },
    hTag: {
      type: String,
      default: 'p'
    }
  },
  data() {
    return {
      font_family: this.fontFamily,
      font_size: this.fontSize,
      color_value: this.colorValue,
      select_color: this.selectColor,
      fs_weight: this.fsWeight,
      fs_italics: this.fsItalics,
      fs_underline: this.fsUnderline,
      text_align: this.textAlign,
      line_height: this.lineHeight,
      patternValue: this.pattern,
      linear_gradient: this.linearGradient,
      timer: null,
      h_tag: this.hTag
    };
  },
  computed: {
    fontFamilyOptions() {      
      if (!this.hasCustomFont) {
        return this.$store.state.options.fontFamilyZh
      } else {
        return [{
          label: i18n.t('components_my_font_family_index_2309'),
          options: this.$store.state.options.fontFamilyZh
        }, {
          label: i18n.t('components_my_font_family_index_2310'),
          options: this.$store.state.options.fontFamilyFree
        }]
      }
    }
  },
  methods: {
    selectEditor() {
      let index = 0
      let id = this.$store.state.app.module_Data.widgets_id
      KindEditor.instances.map((e, i) => {
        if (e.srcElement[0].id === 'editor' + id) {
          index = i
        }
      })
      return KindEditor.instances[index]
    },
    syncHTag() {
      let _KindEditor = this.selectEditor()
      if (!_KindEditor) return
      let tag = (_KindEditor.cmd.val('formatblock') || 'p').toLowerCase()
      if (tag !== this.h_tag) {
        this.h_tag = tag
        this.$emit('update:hTag', tag)
      }
    },
    bindEditorEvents() {
      if (this._eventsBound) return
      let _KindEditor = this.selectEditor()
      if (!_KindEditor || !_KindEditor.edit || !_KindEditor.edit.doc) return
      this._eventsBound = true
      _KindEditor.edit.doc.addEventListener('click', this.syncHTag)
      _KindEditor.edit.doc.addEventListener('keyup', this.syncHTag)
    },
    applyHTag(tag) {
      let _KindEditor = this.selectEditor()
      if (!_KindEditor) return
      this.bindEditorEvents()
      _KindEditor.focus()
      _KindEditor.select()
      _KindEditor.exec('formatblock', tag === 'p' ? '<p>' : `<${tag}>`)
      this.$emit('update:hTag', tag)
    },
    clickBold() {
      let _KindEditor = this.selectEditor()
      if (_KindEditor.cmd.range.collapsed) {
        _KindEditor.cmd.selectall()
      }
      if (this.fs_weight === 'bold') {
        this.$store.commit('font_style/SET_bold', false);
        this.$emit('update:fsWeight', 'normal');
        // this.fs_weight= 'normal';
      } else {
        this.$store.commit('font_style/SET_bold', true);
        this.$emit('update:fsWeight', 'bold');
        // this.fs_weight = 'bold'
      }
      _KindEditor.exec('bold');
      let id = this.$store.state.app.module_Data.widgets_id
      let _that = this
      this.timer = setTimeout(() => {
        if (id) {
          if ($(`#u${id} .ke-selected[data-name='bold']`).length == 1) {
            // $('.icon.bold').addClass('active')
            this.$store.commit('font_style/SET_bold', true);
          } else {
            this.$store.commit('font_style/SET_bold', false);
          }
        }
        _that.timer = null
      }, 200)
    },
    clickItalics() {
      let _KindEditor = this.selectEditor()
      if (_KindEditor.cmd.range.collapsed) {
        _KindEditor.cmd.selectall()
      }
      if (this.fs_italics === 'oblique') {
        this.$store.commit('font_style/SET_italics', false);
        this.$emit('update:fsItalics', 'normal');
      } else {
        this.$store.commit('font_style/SET_italics', true);
        this.$emit('update:fsItalics', 'oblique');
      }
      _KindEditor.exec('italic');
      let id = this.$store.state.app.module_Data.widgets_id
      let _that = this
      this.timer = setTimeout(() => {
        if (id) {
          if ($(`#u${id} .ke-selected[data-name='italic']`).length == 1) {
            this.$store.commit('font_style/SET_italics', true);
          } else {
            this.$store.commit('font_style/SET_italics', false);
          }
        }
        _that.timer = null
      }, 200)
    },
    clickUnderline() {
      let _KindEditor = this.selectEditor()
      if (_KindEditor.cmd.range.collapsed) {
        _KindEditor.cmd.selectall()
      }
      if (this.fs_underline === 'underline') {
        this.$store.commit('font_style/SET_underline', false);
        this.$emit('update:fsUnderline', 'normal');
      } else {
        this.$store.commit('font_style/SET_underline', true);
        this.$emit('update:fsUnderline', 'underline');
      }
      _KindEditor.exec('underline');
      let id = this.$store.state.app.module_Data.widgets_id
      let _that = this
      this.timer = setTimeout(() => {
        if (id) {
          if ($(`#u${id} .ke-selected[data-name='underline']`).length == 1) {
            this.$store.commit('font_style/SET_underline', true);
          } else {
            this.$store.commit('font_style/SET_underline', false);
          }
        }
        _that.timer = null
      }, 200)
    },
    setLink() {
      this.templet.set_link(this.link);
    },
    reSet() { // 清除格式

      if (this.fs_weight === 'bold')this.clickBold();
      
      if (this.fs_italics === 'oblique')this.clickItalics();
      
      if (this.fs_underline === 'underline')this.clickUnderline()

      this.font_family = 'Arial';
      this.font_size = 20;
      this.color_value = 'rgba(51, 51, 51,1)';
      this.select_color = 'rgba(51, 51, 51,1)';
      this.fs_weight = 'normal';
      this.fs_italics = 'normal';
      this.fs_underline = 'none';
      this.text_align = 'left';
      this.line_height = i18n.t('view_back_top_edit_103');
      this.patternValue = 'pure_color';
      this.linear_gradient = {
        start_color: 'rgba(0, 0, 0,1)',
        end_color: 'rgba(0, 0, 0,1)',
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      };
    },
    createFont() {
      let that = this
      that.$nextTick(()=> {
        let widetsId = that.$store.state.app.module_Data.widgets_id
        let selectText = window.getSelection ? $(`#u${widetsId} .ke-edit-iframe`)[0].contentWindow.getSelection().toString() : document.selection.createRange().text
        let text = selectText || $(`#u${widetsId}`).find('.contentPart').text()
        createFont({
          originFontId: Number(that.font_family),
          keyword: text,
          pageName: that.$store.state.app.now_page
        }).then((res) => {
          let font = {
            name: res.data.font_face,
            url: res.data.fonts_file_url
          }
          that.$emit('update:customFont', font);
          let fontList = that.fontList.slice()
          fontList.push(font)
          that.$emit('update:fontList', fontList);
          that.$utils.insertStyle(font)
        })
      })
    }
  },
  mounted() {

  },
  watch: {
    linear_gradient(val) {
      // 数据双向绑定
      this.$emit('update:linearGradient', val);
    },
    patternValue(val) {
      // 数据双向绑定
      this.$emit('update:pattern', val);
    },
    line_height(val) {
      // 数据双向绑定
      this.$emit('update:lineHeight', val);
    },
    font_family(val) {
      let font = [...this.$store.state.options.fontFamilyZh, ...this.$store.state.options.fontFamilyFree].find(f => f.value === val)
      if (font && !font.isSystem) {
        this.createFont()
      } else {
        this.$emit('update:customFont', {
          name: '',
          url: ''
        });
      }
      // 数据双向绑定
      this.$emit('update:fontFamily', val);
    },
    font_size(val) {
      // 数据双向绑定
      this.$emit('update:fontSize', val);
    },
    color_value(val) {
      // 数据双向绑定
      this.$emit('update:colorValue', val);
    },
    select_color(val) {
      // 数据双向绑定
      this.$emit('update:selectColor', val);
    },
    // fs_weight(val) {
    //   // 数据双向绑定
    //   this.$emit('update:fsWeight', val);
    // },
    // fs_italics(val) {
    //   // 数据双向绑定
    //   this.$emit('update:fsItalics', val);
    // },
    // fs_underline(val) {
    //   // 数据双向绑定
    //   this.$emit('update:fsUnderline', val);
    // },
    text_align(val) {
      // 数据双向绑定
      this.$emit('update:textAlign', val);
    },
    linearGradient(val) {
      this.linear_gradient = val;
    },
    pattern(val) {
      this.patternValue = val;
    },
    lineHeight(val) {
      this.line_height = val;
    },
    fontFamily(val) {
      // 数据双向绑定
      this.font_family = val;
    },
    fontSize(val) {
      // 数据双向绑定
      this.font_size = val;
    },
    colorValue(val) {
      // 数据双向绑定
      this.color_value = val;
    },
    selectColor(val) {
      // 数据双向绑定
      this.select_color = val;
    },
    fsWeight(val) {
      // 数据双向绑定
      this.fs_weight = val;
    },
    fsItalics(val) {
      // 数据双向绑定
      this.fs_italics = val;
    },
    fsUnderline(val) {
      // 数据双向绑定
      this.fs_underline = val;
    },
    textAlign(val) {
      // 数据双向绑定
      this.text_align = val;
    },
    hTag(val) {
      this.h_tag = val;
    }
  }
};
</script>

<style scoped type="text/css" lang="scss">
.setTwo {
  margin-top: -12px;
  padding-left: 46px;
}

.h_tag_select {
  width: 100px;
}

.setOne {
  display: flex;
  justify-content: flex-start;
}

.my_font_style {
  margin-top: 20px;
}

.hideTitle /deep/ .title {
  display: none;
}

.minRight /deep/ .color_block {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_rich_text_style/index.vue